import _asyncToGenerator from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _extends from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Layout } from "../components/_global";
import _ from 'lodash';
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
var withPageMeta = function withPageMeta(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    title: '',
    description: '',
    slug: ''
  };
  var HocWithPageMeta = /*#__PURE__*/function (_Component) {
    function HocWithPageMeta() {
      _classCallCheck(this, HocWithPageMeta);
      return _callSuper(this, HocWithPageMeta, arguments);
    }
    _inherits(HocWithPageMeta, _Component);
    return _createClass(HocWithPageMeta, [{
      key: "render",
      value: function render() {
        var page = this.props.page;
        var metaTitle = _.get(page, 'meta.title', options.title);
        var metaDescription = _.get(page, 'meta.description', options.description);
        return __jsx(Layout, {
          title: metaTitle,
          description: metaDescription,
          slug: options.slug
        }, __jsx(WrappedComponent, _extends({}, this.props, {
          page: page
        })));
      }
    }]);
  }(Component);
  HocWithPageMeta.getInitialProps = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var res, page;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              res = _ref.res, page = _ref.query.page;
              return _context.abrupt("return", {
                page: page
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  HocWithPageMeta.displayName = "withPageMeta(".concat(getDisplayName(WrappedComponent), ")");
  return HocWithPageMeta;
};
export default withPageMeta;